import { createGlobalResource } from './createGlobalResource';
import { Project } from 'core/models/project';
import { useEffect, useCallback } from 'react';
import { useProjectRepository } from './useProjectRepository';

const { withGlobalResource, useGlobalResource, useUpdateGlobalResource } = createGlobalResource<Project[]>();

export { withGlobalResource as withProjects };

export function useWithProjects() {
    return useCallback((children: React.ReactNode) => {
        return withGlobalResource(children);
    }, []);
}

export function useUpdateProjects() {
    const repository = useProjectRepository();

    const updater = useCallback(async () => {
        return await repository.getProjects();
    }, [repository]);
    return useUpdateGlobalResource(updater);
}

const emptyProjects: Project[] = [];

export function useProjects() {
    const projects = useGlobalResource();
    const updateProjects = useUpdateProjects();

    useEffect(() => {
        if (projects === undefined) {
            updateProjects();
        }
    }, [projects, updateProjects]);

    return projects ?? emptyProjects;
}
